import * as RDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/** Accessible modal shell (Radix). Destructive actions confirm through it (core doc 04 rule 8). */
export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  wide,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  wide?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <RDialog.Root open={open} onOpenChange={onOpenChange}>
      <RDialog.Portal>
        <RDialog.Overlay className="fixed inset-0 z-40 bg-black/40 backdrop-blur-[2px]" />
        <RDialog.Content
          aria-describedby={description ? undefined : undefined}
          className={`fixed left-1/2 top-[12vh] z-50 ${wide ? "w-[680px]" : "w-[540px]"} max-w-[94vw] -translate-x-1/2 rounded-[var(--radius-panel)] border border-line bg-surface p-6 shadow-[var(--shadow-card)]`}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <RDialog.Title className="text-[20px] font-semibold text-ink">{title}</RDialog.Title>
              {description && (
                <RDialog.Description className="mt-1 text-[14px] text-ink-2">{description}</RDialog.Description>
              )}
            </div>
            <RDialog.Close
              aria-label={t("common.close")}
              className="rounded-[var(--radius-control)] p-1.5 text-ink-2 hover:bg-elevated hover:text-ink"
            >
              <X aria-hidden="true" className="size-5" />
            </RDialog.Close>
          </div>
          <div className="mt-5">{children}</div>
        </RDialog.Content>
      </RDialog.Portal>
    </RDialog.Root>
  );
}
